import { PortraitCenterModule } from '@blade-sxp/portrait-center/store/index';
import { getVisitorIndicators, getVisitorPagelist, getVisitorProportion, getVisitorTrend, getVisitorStay } from '@blade-sxp/portrait-center/api/index';
export const getFuncVisitorIndicators = (params) => {
    return new Promise((resolve, reject) => {
        getVisitorIndicators(params).then((res) => {
            resolve(res);
        }).catch((e) => {
            reject(e);
        }).finally(() => {
            apinum();
        });
    });
};
export const getFuncVisitorPagelist = (params) => {
    return new Promise((resolve, reject) => {
        getVisitorPagelist(params).then((res) => {
            resolve(res);
        }).catch((e) => {
            reject(e);
        }).finally(() => {
            apinum();
        });
    });
};
export const getFuncVisitorProportion = (params) => {
    return new Promise((resolve, reject) => {
        getVisitorProportion(params).then((res) => {
            resolve(res);
        }).catch((e) => {
            reject(e);
        }).finally(() => {
            apinum();
        });
    });
};
export const getFuncVisitorTrend = (params) => {
    return new Promise((resolve, reject) => {
        getVisitorTrend(params).then((res) => {
            resolve(res);
        }).catch((e) => {
            reject(e);
        }).finally(() => {
            apinum();
        });
    });
};
export const getFuncVisitorStay = (params) => {
    return new Promise((resolve, reject) => {
        getVisitorStay(params).then((res) => {
            resolve(res);
        }).catch((e) => {
            reject(e);
        }).finally(() => {
            apinum();
        });
    });
};
const apinum = () => {
    PortraitCenterModule.updateApiRequestNum();
};
